export const MuiTextField = {
  styleOverrides: {
    root: {
      "& .MuiInputLabel-shrink": {
        display: "none",
        "& + .MuiInputBase-root .MuiInputBase-input": {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
      ["input::-webkit-outer-spin-button" && "input::-webkit-inner-spin-button"]: {
        WebkitAppearance: "none",
        margin: 0,
      },
      input: {
        MozAppearance: "textfield",
        color: "#333333 !important",
      },
      "& .MuiInputBase-root": {
        backgroundColor: "#fff !important",
        height: "4.8rem !important",
        "& input::placeholder": {
          opacity: 0.8,
          color: "#333"
        }
      },
      "& .MuiInputBase-root::before": {
        border: "none",
        borderBottomStyle: "unset !important",

        // "&:hover, &:focus": {
        //   borderBottomStyle: "unset !important",
        //   border: "none",
        // },
      },

    },
  },
}
